import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { withLDProvider } from 'launchdarkly-react-client-sdk';
import Observability from '@launchdarkly/observability';
import SessionReplay from '@launchdarkly/session-replay';

// import 'normalize.css';

import './styles/tailwind.css';
import './styles/index.css';
import './styles/app.css';
import './styles/header.css';
// import './styles/dataPages.css';
import './styles/login.css';
import './styles/register.css';
import './styles/dateTime.css';
import './styles/totals.css';
import './styles/select.css';
import './styles/leaderPage.css';
import './styles/adminPage.css';
import './styles/traineePage.css';
import './styles/homePage.css';
import './styles/unityApp.css';
import './styles/administratorPage.css';
import './styles/documentPage.css';
import './styles/logEnginePage.css';
import './styles/subscription.css';
import App from './App';
import store from './redux/store';

// console.log('store:', store)
store.subscribe(() => {
  // console.log('store:', JSON.stringify(store.getState()))
});
// console.log('store:', store.getState())

const Root = () => (
  <Provider store={store}>
    <App />
  </Provider>
);

const ldClientSideID = process.env.REACT_APP_LD_CLIENT_SIDE_ID;
const ldCanvasFps = Number(process.env.REACT_APP_LD_CANVAS_FPS) || 8;
const ldCanvasMaxDimension =
  Number(process.env.REACT_APP_LD_CANVAS_MAX_DIMENSION) || 1440;

const RootComponent = ldClientSideID
  ? withLDProvider({
      clientSideID: ldClientSideID,
      options: {
        plugins: [
          new Observability({
            networkRecording: {
              enabled: true,
              recordHeadersAndBody: true,
            },
          }),
          new SessionReplay({
            privacySetting: 'default',
            enableCanvasRecording: true,
            samplingStrategy: {
              canvasManualSnapshot: ldCanvasFps,
              canvasMaxSnapshotDimension: ldCanvasMaxDimension,
            },
          }),
        ],
      },
    })(Root)
  : Root;

if (!ldClientSideID) {
  console.info('[LD] REACT_APP_LD_CLIENT_SIDE_ID not set — session replay disabled');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<RootComponent />);
